import React from "react"
import { Row, Col } from "react-bootstrap"
import SEO from "../components/seo"
import Img from "gatsby-image"
import Layout from "../components/layout"
import BlogHeading from "../components/BlogHeading"
import styles from "./blog.module.scss"
import { Link, useStaticQuery, graphql } from "gatsby"
import Webdev from "../assets/webdev.svg"

const BlogPage = () => {
  const data = useStaticQuery(graphql`
    query {
      allMarkdownRemark {
        edges {
          node {
            frontmatter {
              date
              title
              Description
            }
            id
            fields {
              slug
            }
          }
        }
      }
      allFile(filter: { relativeDirectory: { eq: "posts/icons" } }) {
        nodes {
          id
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
  `)
  return (
    <Layout className="mx-auto">
      <SEO title="Blog" />
      <BlogHeading />
      <Row className={`mx-0 my-md-2 ${styles.blogRow}`}>
        <Col xs={12} sm={12} md={9} lg={9} xl={9} className={`mx-auto px-0`}>
          <p className="text-muted text-center mt-4 mb-0 d-lg-none">
            List of Articals
          </p>
          <hr
            className="d-lg-none mx-5 my-0"
            style={{ background: "#f15842" }}
          />
          <Row className="mx-0">
            <Col
              xs={12}
              sm={12}
              md={9}
              lg={9}
              xl={9}
              className="px-0 mx-auto my-2"
            >
              <Row className={`mb-2 m-auto`}>
                <Col className={`m-auto px-0`}>
                  <ol className={`${styles.imageCol}`}>
                    {data.allMarkdownRemark.edges.map((edge, index) => {
                      return (
                        <li
                          className="border shadow mx-2 my-3"
                          key={edge.node.id}
                        >
                          <Row className={`mx-0 p-2 ${styles.articalColum}`}>
                            <Col xs={8} sm={8} md={6} lg={6} className="m-auto">
                              <p
                                className={`pl-3 mb-0 text-muted ${styles.subHeading}`}
                              >
                                {edge.node.frontmatter.date}
                              </p>
                              <Link to={`/Blog/${edge.node.fields.slug}`}>
                                <h2
                                  className={`mb-1 pl-3 pr-1 ${styles.headding}`}
                                >
                                  {edge.node.frontmatter.title}
                                  <abbr
                                    title="Read this artical"
                                    className={`pr-4 float-right ${styles.customBlogBtn}`}
                                    type="button"
                                  >
                                    <span
                                      className={`text-danger ${styles.headding}`}
                                    >
                                      &#8594;
                                    </span>
                                  </abbr>
                                </h2>
                                <p className="pt-2 pl-3 mb-0 text-secondary d-none d-sm-block">
                                  {edge.node.frontmatter.Description}
                                </p>
                              </Link>
                            </Col>
                            <Col xs={4} sm={4} md={3} lg={3} className="m-auto">
                              <Img
                                fluid={{
                                  ...data.allFile.nodes[index].childImageSharp
                                    .fluid,
                                }}
                                objectFit="cover"
                                objectPosition="50% 50%"
                                alt="blog-post"
                                className="rounded m-auto"
                              />
                            </Col>
                          </Row>
                        </li>
                      )
                    })}
                  </ol>
                </Col>
              </Row>
            </Col>
            <Col
              md={3}
              lg={3}
              className={`my-3 py-2 mx-auto d-none d-sm-block ${styles.sidePanel}`}
            >
              <h5 className="card-header text-center">Advertisment</h5>
              <div className="card-body">
                <Webdev />
              </div>
            </Col>
            <Col>
              <ul className="pagination justify-content-center mt-4 mb-4">
                <li className="page-item">
                  <a className="page-link" href="https://sungharsh.github.io/">
                    &larr; Older
                  </a>
                </li>
                <li className="page-item disabled">
                  <a className="page-link" href="https://sungharsh.github.io/">
                    Newer &rarr;
                  </a>
                </li>
              </ul>
            </Col>
          </Row>
        </Col>
      </Row>
    </Layout>
  )
}
export default BlogPage
